module.exports = __webpack_public_path__ + "img/ctimes.3ab27385.png";